export default `vec3 Q=p;
    float i,d=1.,c;
    Q.x+=M_PI/2.;
    c=dot(sin(Q),cos(Q.yzx))+1.;
    d=7.-length(p.xy);
    return d=(c+d-sqrt((c-d)*(c-d)+.2))*.5+snoise3D(p)*.1;
  }`